
import React from "react";
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import { faCashRegister, faChartLine, faCloudUploadAlt, faPlus, faRocket, faTasks, faUserShield } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Tooltip, Overlay} from 'react-bootstrap';
import { SalesValueWidget, PopularAssetsWidget, CountriesRegistrationWidget, RegistrationMapWidget} from '../../components/Widgets'
//import { CounterWidget, CircleChartWidget, BarChartWidget, TeamMembersWidget, ProgressTrackWidget, RankingWidget, SalesValueWidget, SalesValueWidgetPhone, AcquisitionWidget } from "../../components/Widgets";
import { ClientsTable, IbsTable } from "../../components/Tables";
import { totalOrders } from "../../data/charts";
import './dashboard.scss'
import {
  faTable,
  faAddressBook,
  faUserTie,
  faDollarSign,
  faChartLine
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon,  } from "@fortawesome/react-fontawesome";
import { useAuth } from "../../hooks/auth.hook";

export default () => {
  const {user: authUser} = useAuth();


  return (
    <>
    {authUser.id !== null && authUser.ib_number !== undefined && (
      <>
        <section className="section-header overflow-hidden pt-5 pt-lg-6 pb-9 pb-lg-12 bg-primary text-white">
        <Row>
          <Col xs={12}>
            <h3>Tablas <FontAwesomeIcon icon={faTable}></FontAwesomeIcon></h3>
          </Col>
        </Row>
        {(authUser.is_staff || authUser.is_admin) && (
          <Row className="text-right">
              <Col xs={12}>
                <h3>Afiliados <FontAwesomeIcon icon={faUserTie}></FontAwesomeIcon></h3>
              </Col>
            </Row>
        )}
      {(authUser.is_staff || authUser.is_admin) && (
        <Row className="justify-content-md-center">
          <Col xs={12}className="mb-4 d-none d-sm-block">
            <IbsTable type="all"
                actions={[
                  {
                      type: "search"
                  }]}
              />
          </Col>
        </Row>
      )}
      <Row>
        <Col xs={12} className="text-right">
              <h3>Clientes <FontAwesomeIcon icon={faAddressBook}></FontAwesomeIcon></h3>
        </Col>
      </Row>
      <Row className="justify-content-md-center">
          <Col xs={12} className="mb-4 d-none d-sm-block">
            <ClientsTable type="all"
                actions={[
                  {
                      type: "search"
                  },
                  {
                      type: "export"
                  }
                ]}
                showIbNumbRow={!authUser.is_afiliate}
              />
          </Col>
      </Row>
      </section>
      <section className="section-header overflow-hidden pt-5 pt-lg-6 pb-9 pb-lg-12 bg-primary text-white"  >
        <Row>
          <Col xs={12}>
            <h3>Gráficas <FontAwesomeIcon icon={faChartLine}></FontAwesomeIcon></h3>
          </Col>
        </Row>
        <Row className="text-right">
          <Col xs={12}>
            <h3>Ganancias mensual <FontAwesomeIcon icon={faDollarSign}></FontAwesomeIcon></h3>
          </Col>
        </Row>
        <Row className="text-black" style={{paddingLeft: "1rem", paddingRight: "1rem"}}>
          <SalesValueWidget
                title="Ganancias"
                ibNumber={authUser.ib_number}
              />
        </Row>
        <Row className="text-right">
          <Col xs={12}>
            <h3>Assets Populares <FontAwesomeIcon icon={faDollarSign}></FontAwesomeIcon></h3>
          </Col>
        </Row>
        <Row className="text-black">
          <Col xs={12}>
            <PopularAssetsWidget
              title="Pares y monedas populares"
              ibNumber={authUser.ib_number}
              />
          </Col>
        </Row>
        <Row className="text-right">
          <Col xs={12}>
            <h3>Registros por país <FontAwesomeIcon icon={faDollarSign}></FontAwesomeIcon></h3>
          </Col>
        </Row>
        {/* TODO FILL COUNTRIES WITH PRIMARY WHEN THERE'S REGISTRATIONS ON THOSE COUNTRIES AND SET UP A NEW BAR CHART WITH COUNTRIES AND REGISTER COUNT */}
        <Row className="text-black">
          <Col xs={5}>
            <RegistrationMapWidget ibNumber={authUser.ib_number}></RegistrationMapWidget>
          </Col>
          <Col xs={7}>
                <CountriesRegistrationWidget title="Registros por país"
                ibNumber={authUser.ib_number} ></CountriesRegistrationWidget>
          </Col>
        </Row>
      </section>
      </>
    )}
            {/* <Col xs={12} className="mb-4 d-none d-sm-block">
          <SalesValueWidget
            title="Sales Value"
            value="10,567"
            percentage={10.57}
          />
        </Col>
        <Col xs={12} className="mb-4 d-sm-none">
          <SalesValueWidgetPhone
            title="Sales Value"
            value="10,567"
            percentage={10.57}
          />
        </Col>
        <Col xs={12} sm={6} xl={4} className="mb-4">
          <CounterWidget
            category="Customers"
            title="345k"
            period="Feb 1 - Apr 1"
            percentage={18.2}
            icon={faChartLine}
            iconColor="shape-secondary"
          />
        </Col>

        <Col xs={12} sm={6} xl={4} className="mb-4">
          <CounterWidget
            category="Revenue"
            title="$43,594"
            period="Feb 1 - Apr 1"
            percentage={28.4}
            icon={faCashRegister}
            iconColor="shape-tertiary"
          />
        </Col>

        <Col xs={12} sm={6} xl={4} className="mb-4">
          <CircleChartWidget
            title="Traffic Share"
            data={trafficShares} /> 
        </Col>*/}
      {/* <Row>
        <Col xs={12} xl={12} className="mb-4">
          <Row>
            <Col xs={12} xl={8} className="mb-4">
              <Row>
                <Col xs={12} className="mb-4">
                  <PageVisitsTable />
                </Col>

                <Col xs={12} lg={6} className="mb-4">
                  <TeamMembersWidget />
                </Col>

                <Col xs={12} lg={6} className="mb-4">
                  <ProgressTrackWidget />
                </Col>
              </Row>
            </Col>

            <Col xs={12} xl={4}>
              <Row>
                <Col xs={12} className="mb-4">
                  <BarChartWidget
                    title="Total orders"
                    value={452}
                    percentage={18.2}
                    data={totalOrders} />
                </Col>

                <Col xs={12} className="px-0 mb-4">
                  <RankingWidget />
                </Col>

                <Col xs={12} className="px-0">
                  <AcquisitionWidget />
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row> */}
    </>
  );
};
